/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ats_Score_NudgeInputs */

const en_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to improve this score? Tailor your resume for a specific job.`)
};

const de_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score verbessern? Passe deinen Lebenslauf an eine bestimmte Stelle an.`)
};

const fr_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envie d'améliorer ce score ? Adapte ton CV à une offre précise.`)
};

const es_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres mejorar esta puntuación? Adapta tu CV a una oferta concreta.`)
};

const it_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi migliorare questo punteggio? Adatta il tuo CV a un'offerta specifica.`)
};

const nl_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wil je deze score verbeteren? Pas je CV aan op een specifieke vacature.`)
};

const pl_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chcesz poprawić wynik? Dostosuj CV do konkretnej oferty pracy.`)
};

const fi_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haluatko parantaa tulosta? Räätälöi ansioluettelosi tiettyyn työpaikkaan.`)
};

const da_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vil du forbedre denne score? Tilpas dit CV til et specifikt job.`)
};

const sv_onboarding_ats_score_nudge = /** @type {(inputs: Onboarding_Ats_Score_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vill du förbättra resultatet? Anpassa ditt CV till ett specifikt jobb.`)
};

/**
* | output |
* | --- |
* | "Want to improve this score? Tailor your resume for a specific job." |
*
* @param {Onboarding_Ats_Score_NudgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_ats_score_nudge = /** @type {((inputs?: Onboarding_Ats_Score_NudgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ats_Score_NudgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_ats_score_nudge(inputs)
	if (locale === "fr") return fr_onboarding_ats_score_nudge(inputs)
	if (locale === "es") return es_onboarding_ats_score_nudge(inputs)
	if (locale === "it") return it_onboarding_ats_score_nudge(inputs)
	if (locale === "nl") return nl_onboarding_ats_score_nudge(inputs)
	if (locale === "pl") return pl_onboarding_ats_score_nudge(inputs)
	if (locale === "fi") return fi_onboarding_ats_score_nudge(inputs)
	if (locale === "da") return da_onboarding_ats_score_nudge(inputs)
	if (locale === "sv") return sv_onboarding_ats_score_nudge(inputs)
	return en_onboarding_ats_score_nudge(inputs)
});